<template>
  <div>
    <p class="operation"><router-link to="/">{{$t('Home')}}</router-link> >> <router-link to="/productDisplay">{{$t('Project')}}</router-link> >> {{$t('IBMS')}}</p>
    <p class="caption headline">{{ $t('Project')}}</p>
    <!--<p class="caption">方案展示</p>-->
    <p class="title">{{$t('IBMS')}}</p>
    <div class="product-display">
      <p>&nbsp; &nbsp; &nbsp; &nbsp;{{$t('text4[0]')}}</p>
      <p>&nbsp; &nbsp; &nbsp; &nbsp;{{$t('text4[1]')}}</p>
      <p>&nbsp; &nbsp; &nbsp; &nbsp;{{$t('text4[2]')}}</p>
      <img src="../assets/img/pic/pc_pd_v4_1.png">
      <p class="imgName">{{$t('text4[3]')}}</p>
      <p>&nbsp; &nbsp; &nbsp; &nbsp;{{$t('text4[4]')}}</p>
    </div>
  </div>
</template>
<script>
  export default {
    name: "pd_v4",
    data() {
      return {
        //，澳门金沙集团AP系统升级更新
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pd_v4.vue